import withRender from './twofactor_timer.vue.html';

export default withRender({
    name: 'two-factor-timer',

    props: {
        twofactorMethod: { type: String, default: 'sms' },
        requestTimeout: { type: [Number, String], default: 0 },
        resendAvailableAt: { type: [Number, String], default: 0 },
        windowAvailableAt: { type: [Number, String], default: 0 },
        isLastAttempt: { type: [Boolean, String], default: false },
    },
    data() {
        return {
            isVisible: false,
            localResendAvailableAt: 0,
            localWindowAvailableAt: 0,
            localIsLastAttempt: false,
            countdownInterval: null,
            remainingSeconds: 0,
            showTimer: false,
            showLimitMessage: false,
            timerMinutes: '00',
            timerSeconds: '00',
            limitDate: '',
            limitTime: '',
        };
    },
    watch: {
        resendAvailableAt: { handler: 'initAndProcess', immediate: true },
        windowAvailableAt: { handler: 'initAndProcess', immediate: true },
        isLastAttempt: { handler: 'initAndProcess', immediate: true },

        '$store.state.cellphone_recovery': { handler: 'initAndProcess', deep: true, immediate: true }
    },
    mounted() {
        this.initAndProcess();
    },
    beforeDestroy() {
        this.cleanup();
    },
    unmounted() {
        this.cleanup();
    },
    methods: {
        emitToggleButton(value) {
            setTimeout(() => {
                this.$emit('toggle-button', value);
            }, 0);
        },

        initAndProcess() {
            const store = this.$store && this.$store.state;
            const globalState = (store && store.cellphone_recovery) || {};

            const propIsLast = this.isLastAttempt === true || this.isLastAttempt === 'true';
            const globalIsLast = globalState.is_last_attempt === true
                || globalState.is_last_attempt === 'true'
                || globalState.isLastAttempt === true
                || globalState.isLastAttempt === 'true';

            this.localIsLastAttempt = propIsLast || globalIsLast;
            /* eslint-disable max-len */
            const propResend = parseInt(this.resendAvailableAt, 10) || 0;
            const globalResend = parseInt(globalState.resend_available_at || globalState.resendAvailableAt, 10) || 0;

            this.localResendAvailableAt = Math.max(propResend, globalResend);

            const propWindow = parseInt(this.windowAvailableAt, 10) || 0;
            const globalWindow = parseInt(globalState.window_available_at || globalState.windowAvailableAt, 10) || 0;

            this.localWindowAvailableAt = Math.max(propWindow, globalWindow);
            if (propResend > 0) {
                this.localResendAvailableAt = Math.max(propResend, globalResend);
            } else {
                this.localResendAvailableAt = globalResend;
            }
            this.processTimer();
        },

        processTimer() {
            if (this.localIsLastAttempt) {
                this.cleanup();
                this.emitToggleButton(true);
                this.initLimitMessage();
                return;
            }

            const nowMs = Date.now();
            const targetMs = this.localResendAvailableAt * 1000;
            const totalMs = targetMs - nowMs;

            if (totalMs <= 0) {
                this.emitToggleButton(false);
                this.showTimer = false;
                this.showLimitMessage = false;
                this.hide();
                this.cleanup();
                return;
            }

            this.emitToggleButton(true);
            this.startCountdown(this.localResendAvailableAt);
        },

        startCountdown(availableAtSec) {
            this.show();
            this.showTimer = true;
            this.showLimitMessage = false;

            if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
            }

            const updateTimer = () => {
                const nowSec = Math.floor(Date.now() / 1000);
                this.remainingSeconds = availableAtSec - nowSec;

                if (this.remainingSeconds <= 0) {
                    clearInterval(this.countdownInterval);
                    this.emitToggleButton(false);
                    this.showTimer = false;
                    this.hide();
                    return;
                }
                this.updateTimerDisplay();
            };

            updateTimer();
            if (this.remainingSeconds > 0) {
                this.countdownInterval = setInterval(updateTimer, 1000);
            }
        },

        updateTimerDisplay() {
            const mins = Math.floor(this.remainingSeconds / 60);
            const secs = this.remainingSeconds % 60;
            this.timerMinutes = String(mins).padStart(2, '0');
            this.timerSeconds = String(secs).padStart(2, '0');
        },

        initLimitMessage() {
            this.cleanup();
            this.show();

            let targetSeconds = 0;

            if (this.localWindowAvailableAt > 0) {
                const deltaSeconds = this.localResendAvailableAt - this.localWindowAvailableAt;

                const nowSeconds = Math.floor(Date.now() / 1000);

                targetSeconds = nowSeconds + deltaSeconds;
            } else {
                targetSeconds = this.localResendAvailableAt;
            }

            if (!targetSeconds) {
                this.showTimer = false;
                this.showLimitMessage = true;
                return;
            }

            const targetDate = new Date(targetSeconds * 1000);
            const nowDate = new Date();

            const isToday = nowDate.getDate() === targetDate.getDate()
                && nowDate.getMonth() === targetDate.getMonth()
                && nowDate.getFullYear() === targetDate.getFullYear();

            if (isToday) {
                this.limitDate = window.gettext ? window.gettext('сегодня') : 'сегодня';
            } else {
                this.limitDate = this.formatDate(targetDate);
            }

            this.limitTime = this.formatTime(targetDate);

            this.showTimer = false;
            this.showLimitMessage = true;
        },

        formatDate(date) {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}.${month}.${year}`;
        },

        formatTime(date) {
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${hours}:${minutes}`;
        },

        hide() { this.isVisible = false; },
        show() { this.isVisible = true; },
        cleanup() {
            if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
                this.countdownInterval = null;
            }
        },
    },
});
